import { CmpManageInvoiceFiltersInput } from "../../../../graphql/types";

// Search relevance (IF10, Moeen Q27). CAP orders the search matches by
// relevance (customer name and invoice number first) only when the request
// says so. The default sort (Issue Date, newest first) and a clicked Issue
// Date sort send the same sortColumn, so the page sends this flag while a
// search is active and staff have not clicked a column header.
export const getManageInvoiceOrderSearchByRelevance = ({
  filters,
  sortChosenByStaff,
}: {
  filters: Pick<CmpManageInvoiceFiltersInput, "invoiceNumberSearchQuery" | "memberSearchQuery">;
  sortChosenByStaff: boolean;
}): boolean =>
  !sortChosenByStaff &&
  [filters.memberSearchQuery, filters.invoiceNumberSearchQuery].some(
    (value) => !!(value || "").trim(),
  );
